import { TipoClassificacao } from './tipo-classificacao';

/** Dados dos KPIs de produtividade */
export class Produtividade {
    tiposClassificacoes: TipoClassificacao[];

    constructor(props: Partial<Produtividade>) {
        Object.assign(this, props);
        // Tipos de Classificações
        this.constructorTiposClassificacoes(props?.tiposClassificacoes ?? []);
    }

    /** Constructor para os tipos de clasificações */
    private constructorTiposClassificacoes(tiposClassificacoes: TipoClassificacao[]) {
        if (tiposClassificacoes && Array.isArray(tiposClassificacoes)) {
            this.tiposClassificacoes = tiposClassificacoes.map(tipoClassificacao => new TipoClassificacao(tipoClassificacao));
        } else {
            this.tiposClassificacoes = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Produtividade {
        return new Produtividade(JSON.parse(json));
    }
}
